import {Component, Injector} from "@angular/core";
import {AbstractSelectSearchControlComponent} from "./abstract-select-search-control.component";
import {registerSearchControl} from "../abstract-search-control.component";

/**
 * Provides a single selection on a search form. <wbo-select-options> is used to provide the options.
 */
@Component({
    selector: "wbo-single-select-search-control",
    templateUrl: "./single-select-search-control.component.html",
    providers: [
        registerSearchControl(SingleSelectSearchControlComponent)
    ]
})
export class SingleSelectSearchControlComponent extends AbstractSelectSearchControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);
    }
}
